import { render, staticRenderFns } from "./FormCategoria.vue?vue&type=template&id=3c71c400&"
import script from "./FormCategoria.vue?vue&type=script&lang=js&"
export * from "./FormCategoria.vue?vue&type=script&lang=js&"
import style0 from "./FormCategoria.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports